import { EMAIL } from 'constants/regexp';

export function isEmail(string) {
  return EMAIL.test(String(string).toLowerCase());
}
